import { ProfilePageView } from './Profile.view';
import { UserRoles } from '@dynamika-shared/types/auth';
import { useAuthSlice } from '@restore/auth/auth.slice';

export const ProfilePage = () => {
  const [userData, setUserRole] = useAuthSlice((state, actions) => [
    state.data,
    actions.setUserRole,
  ]);
  if (!userData) {
    return null;
  }

  const handleUserRole = (role: UserRoles) => {
    setUserRole(role);
  };
  return <ProfilePageView user={userData} handleUserRole={handleUserRole} />;
};
